"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FullWidthImage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="11659" id="visualbreak" className="w-full bg-background !p-0 !h-[650px] bg-cover bg-center !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/auit-1364x650-1.png)] !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/04/auit-2048x1683-1.jpg)]">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="overflow-hidden rounded-sm shadow-xl bg-primary/5">
          
        </div>
      </div>
    </section>;
}